<template>
    <transition v-if="showModal">
        <div
            class="fixed right-0 left-0 top-0 bottom-0 z-[99] bg-[#707070] bg-opacity-30 flex justify-center items-center px-5"
        >
            <div
                class="bg-white border-[1px] border-gray-200 rounded-2xl max-w-[348px] w-full px-4 py-4 relative flex flex-col gap-y-4 items-center justify-center"
            >
                <h1 class="text-primary text-center font-bold text-xl">
                    {{ title }}
                </h1>
                <button class="absolute right-2 top-2" @click="onCloseModal()">
                    <Icon name="Fechar" />
                </button>
                <p v-if="text" class="mt-2.5 text-center" v-html="text"></p>
                <p v-else>Nada para ver aqui</p>

                <a v-if="buttonText" @click="onCloseModal(true)" :href="callToAction">
                    <Button class="bg-primary !text-white p-3 w-[min-content] whitespace-nowrap">
                        {{ buttonText }}
                    </Button>
                </a>
            </div>
        </div>
    </transition>
</template>

<script>
import Icon from "@/Components/UI/Icons/Icon.vue";
import HeadingGuest from "@/Components/UI/Texts/HeadingGuest.vue";
import Button from "@/Components/Button.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import TitleDescription from "@/Components/TitleDescription.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";

export default {
    components: {
        Icon,
        HeadingGuest,
        Button,
        Heading,
        TitleDescription,
        ValidationErrors,
    },

    props: {
        showModal: Boolean,
        notification: Object,
    },

    data() {
        return {
            errors: [],
        };
    },

    emits: ["closeModal"],

    computed: {
        title() {
            return this.notification?.title || "Novidades!";
        },
        text() {
            return this.notification?.text || "";
        },
        buttonText() {
            return this.notification?.buttonLabel || "";
        },
        callToAction() {
            return this.notification?.hyperlink || "#";
        },
    },
    methods: {
        onCloseModal(isUsed = false) {
            this.$emit("closeModal", { isUsed });
        },
    },
};
</script>
<style scoped>
.hidden-scroll-bar::-webkit-scrollbar {
    display: none;
}
</style>
